import { z } from 'zod';
import { Users } from '../db-entries/user.js';
import { CustomProfileFieldType, customProfileFieldTypeGuard, userProfileAddressKeys, userProfileGuard, } from '../foundations/index.js';
const baseProfileFieldGuard = z.object({
    name: z.string(),
    type: customProfileFieldTypeGuard,
    label: z.string(),
    description: z.string().optional(),
    required: z.boolean().optional(),
});
export const textProfileFieldGuard = baseProfileFieldGuard.extend({
    type: z.literal(CustomProfileFieldType.Text),
    config: z
        .object({
        placeholder: z.string().optional(),
        minLength: z.number().optional(),
        maxLength: z.number().optional(),
    })
        .optional(),
});
export const numberProfileFieldGuard = baseProfileFieldGuard.extend({
    type: z.literal(CustomProfileFieldType.Number),
    config: z
        .object({
        placeholder: z.string().optional(),
        minValue: z.number().optional(),
        maxValue: z.number().optional(),
    })
        .optional(),
});
export const dateProfileFieldGuard = baseProfileFieldGuard.extend({
    type: z.literal(CustomProfileFieldType.Date),
    config: z
        .object({
        placeholder: z.string().optional(),
        format: z.string(),
    })
        .optional(),
});
export const checkboxProfileFieldGuard = baseProfileFieldGuard.extend({
    type: z.literal(CustomProfileFieldType.Checkbox),
    config: z.object({
        options: z.array(z.object({ label: z.string(), value: z.string() })),
    }),
});
export const selectProfileFieldGuard = baseProfileFieldGuard.extend({
    type: z.literal(CustomProfileFieldType.Select),
    config: z.object({
        placeholder: z.string().optional(),
        options: z.array(z.object({ label: z.string(), value: z.string() })),
    }),
});
export const urlProfileFieldGuard = baseProfileFieldGuard.extend({
    type: z.literal(CustomProfileFieldType.Url),
    config: z
        .object({
        placeholder: z.string().optional(),
    })
        .optional(),
});
export const regexProfileFieldGuard = baseProfileFieldGuard.extend({
    type: z.literal(CustomProfileFieldType.Regex),
    config: z.object({
        placeholder: z.string().optional(),
        format: z.string(),
    }),
});
export const addressProfileFieldGuard = baseProfileFieldGuard.extend({
    type: z.literal(CustomProfileFieldType.Address),
    config: z.object({
        parts: z.array(z.object({
            key: z.enum(userProfileAddressKeys),
            enabled: z.boolean(),
        })),
    }),
});
const fullnameKeys = userProfileGuard
    .pick({
    givenName: true,
    middleName: true,
    familyName: true,
})
    .keyof().options;
export const fullnameProfileFieldGuard = baseProfileFieldGuard.extend({
    type: z.literal(CustomProfileFieldType.Fullname),
    config: z.object({
        parts: z.array(z.object({ key: z.enum(fullnameKeys), enabled: z.boolean() })),
    }),
});
export const customProfileFieldUnionGuard = z.discriminatedUnion('type', [
    textProfileFieldGuard,
    numberProfileFieldGuard,
    dateProfileFieldGuard,
    checkboxProfileFieldGuard,
    selectProfileFieldGuard,
    urlProfileFieldGuard,
    regexProfileFieldGuard,
    addressProfileFieldGuard,
    fullnameProfileFieldGuard,
]);
export const builtInCustomProfileFieldKeys = Object.freeze(userProfileGuard
    .merge(Users.createGuard.pick({
    name: true,
    primaryEmail: true,
    primaryPhone: true,
    avatar: true,
}))
    .keyof().options);
export const updateCustomProfileFieldDataGuard = z.discriminatedUnion('type', [
    textProfileFieldGuard.omit({ name: true }),
    numberProfileFieldGuard.omit({ name: true }),
    dateProfileFieldGuard.omit({ name: true }),
    checkboxProfileFieldGuard.omit({ name: true }),
    selectProfileFieldGuard.omit({ name: true }),
    urlProfileFieldGuard.omit({ name: true }),
    regexProfileFieldGuard.omit({ name: true }),
    addressProfileFieldGuard.omit({ name: true }),
    fullnameProfileFieldGuard.omit({ name: true }),
]);
export const updateCustomProfileFieldSieOrderGuard = z.object({
    name: z.string(),
    sieOrder: z.number(),
});
